import { createStore } from 'owa-satcheljs';
import type { EasidResponse } from 'owa-licensing-utils/lib/schema/EasidResponse';
import type {
    AccountLinkStore,
    PremiumStatus,
    DialogState,
    EntryPoint,
    AccountLinkStatus,
} from './schema/AccountLinkStore';
import { getAccountKeyForMailboxInfo, type AccountKey, type MailboxInfo } from 'owa-client-types';

export function getDialogStateKey(mailboxInfo: MailboxInfo, entryPoint: EntryPoint): string {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    return `${accountKey}${entryPoint}`;
}

export const getAccountLinkStore: () => AccountLinkStore = createStore<AccountLinkStore>(
    'accountLinkStore',
    {
        entries: new Map<string, EasidResponse>(),
        premiumEntries: new Map<string, PremiumStatus>(),
        dialogState: new Map<string, DialogState>(),
        accountToLink: undefined,
        accountToSignIn: undefined,
        selectedMsaAccount: undefined,
        msaLinkStatusMap: new Map<AccountKey, AccountLinkStatus>(),
    }
);
